import React from 'react'
import PropTypes from 'prop-types'

const styles = {
    fieldName: {
        fontSize: 13,
        fontWeight: '600',
        color: '#aaa',
    },
    fieldValue: {
        fontSize: 13,
        fontWeight: '400',
        color: '#333',
    },
}

const CoopInfoItem = ({ title, value }) => {
    return value
        ? <div>
            <span className={styles.fieldName}>
                {title}:&nbsp;
            </span>
            <span className={styles.fieldValue}>
                {value}
            </span>
        </div>
        : null
}

CoopInfoItem.propTypes = {
    title: PropTypes.string,
    value: PropTypes.string,
}

export default CoopInfoItem



// WEBPACK FOOTER //
// ./src/components/CoopInfoItem.js